import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { provideMomentDateAdapter } from '@angular/material-moment-adapter';

export const MY_FORMATS = {
  parse: {
    dateInput: 'YYYY',
  },
  display: {
    dateInput: 'YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-year-picker',
  templateUrl: './year-picker.component.html',
  styleUrls: ['./year-picker.component.scss'],
  providers: [provideMomentDateAdapter(MY_FORMATS)],
  standalone: false,
})
export class YearPickerComponent {
  @Input() isReadOnly: boolean = false;
  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('yearPicker') yearOfPassing: UntypedFormControl;
  @Output() yearSelected = new EventEmitter<any>();

  constructor() {}

  setYear(dateMoment, datePicker) {
    console.log(dateMoment);
    this.yearOfPassing.setValue(dateMoment);
    datePicker.close();
  }
  clearYear() {
    this.yearOfPassing.setValue(null);
  }
}
